export const combinedTags = [
  'cleanser with salicylic acid'
]

export const categoryTags = [
  'gentle cleansing',
  'gentle cleanser',
  'cleansing',
  'toner',
  'exfoliation',
  'eye care',
  'sunscreen',
  'make-up remover',
  'serum',
  'mask',
  'moisturizer',
  'clay masks',
  'hydrating masks',
  'pad',
  'neck care',
  'lip care',
  'facial mask',
  'face oil'
]

export const specificTags = [
  'aloe vera',
  'acne',
  'vitamin c',
  'salicylic acid',
  'niacinamide (Vitamin B3)',
  'dryness',
  'antioxidant',
  'hydrating',
  'hyaluronic acid',
  'hyperpigmentation',
  'anti-wrinkles',
  'anti-aging',
  'calm redness',
  'balancing pH',
  'night routine',
  'morning routine',
  'sensitive skin',
  'impurities',
  'retinol',
  'oiliness',
  'oil-control',
  'blackheads',
  'dark circles',
  'combination-oily skin',
  'pregnant',
  'sun protection',
  'oily skin',
  'combination-dry skin',
  'anti-dullness',
  'large pores',
  'UV',
  'acne scar', 
  'make-up',
  'no make-up',
  'collagen',
  'wound healing',
  'smooth skin texture',
  'skin plump',
  'After sun',
  'Chemical filter', 
  'physical filter', 
  'chemical+physical filter',
  'peptides',
  'licorice extract',
  'reduce sebum',
  'waterproof',
  'men care', 
  'normal skin',
  'puffiness',
  'puffy',
  'rosehip seed oil',
  'benzoyl peroxide',
  'pollution',
  'fragrance-free',
  'skin repair',
  'vitamin E',
  'drying alcohols',
  'tea tree',
  'even skin tone',
  'eczema',
  'lightweight texture',
  'rosacea',
  'non-comedogenic'
]

// priority tag till 'sensitive skin'
/*export const tags =
 [
  'sunscreen',
  'gentle cleansing',
  'gentle cleanser',
  'eye care',
  'aloe vera',
  'acne',
  'vitamin c',
  'exfoliation',
  'salicylic acid',
  'niacinamide (Vitamin B3)',
  'niacinamide',
  'dryness',
  'antioxidant',
  'hydrating',
  'hyaluronic acid',
  'hyperpigmentation',
  'anti-wrinkles',
  'anti-aging',
  'calm redness',
  'balancing pH',
  'night routine',
  'morning routine',
  'sensitive skin',
  'retinol',
  'oiliness',
  'oil-control',
  'cleansing',
  'toner',
  'blackheads',
  'dark circles',
  'combination-oily skin',
  'pregnant',
  'sun protection',
  'face oil',
  'oily skin',
  'combination-dry skin',
  'anti-dullness',
  'impurities',
  'large pores',
  'UV',
  'acne scar', 
  'make-up',
  'no make-up',
  'make-up remover',
  'collagen',
  'wound healing',
  'smooth skin texture',
  'skin plump',
  'After sun',
  'Chemical filter', 
  'physical filter', 
  'chemical+physical filter',
  'serum',
  'peptides',
  'licorice extract',
  'mask',
  'moisturizer',
  'reduce sebum',
  'waterproof',
  'men care', 
  'clay masks',
  'normal skin',
  'puffiness',
  'rosehip seed oil',
  'benzoyl peroxide',
  'hydrating masks',
  'pollution',
  'fragrance-free',
  'skin repair',
  'pad',
  'vitamin E',
  'drying alcohols',
  'tea tree',
  'neck care',
  'lip care', 
  'facial mask',
  'even skin tone',
  'eczema',
  'lightweight texture',
  'rosacea',
  'non-comedogenic'
  ];*/

  export const getMappedTags = (aiTag: string): string => {
    if (aiTag === 'oiliness') {
      return 'reduce sebum';
    } else if (aiTag === 'oil-control') {
      return 'reduce sebum';
    } else if (aiTag === 'gentle cleanser') {
      return 'gentle cleansing';
    } else if (aiTag === 'puffy') {
      return 'puffiness'
    } else if (aiTag === 'cleanser') {
      return 'cleansing';
    }
    else {
      return aiTag;
    }
  };

export const cleanAnswer = (aiAnswer: string): string => {
  if (aiAnswer.includes('niacinamide (Vitamin B3)')) {
    return aiAnswer;
  } else if (aiAnswer.includes('niacinamide')) {
    return aiAnswer.replace('niacinamide', 'niacinamide (Vitamin B3)');
  }
  return aiAnswer;
}